import { createClient } from "@supabase/supabase-js";

// On ajoute ces deux lignes pour calmer TypeScript
// @ts-ignore
const env = process.env;

const supabaseUrl = env.REACT_APP_SUPABASE_URL || "";
const supabaseAnonKey = env.REACT_APP_SUPABASE_ANON_KEY || "";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
